import HeroCarousel from './components/hero-carousel';
import VideoHero from './components/VideoHero';
import Accordion from './components/Accordion';
import $ from 'jquery';
import { createVideoPlayer } from 'common/utils/video';
import Waypoint from 'waypoints/lib/noframework.waypoints';
import animateDinosaur from './components/dinosaur';
import animateLeopardGirl from './components/leopard-girl';
import { once } from 'lodash';
import createScrollableElements, { centerAlignScrollableElement, scrollOnHover } from './components/scrollable';
import { trackLinkClick, trackEvent } from 'common/utils/analytics';

// Event tracking
document.addEventListener('DOMContentLoaded', () => {
    for (const link of document.querySelectorAll('[data-category]')) {
        trackLinkClick(link, 'Clicked Home Featured Category Link', {
            category: link.getAttribute('data-category')
        });
    }

    const enterpriseCTA = document.querySelector('[data-home-enterprise-cta]');

    if (enterpriseCTA) {
        trackLinkClick(enterpriseCTA, 'Clicked Home Enterprise CTA');
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const carouselElement = document.querySelector('[data-carousel]');

    HeroCarousel.create({
        intervalTime: parseInt(carouselElement.getAttribute('data-carousel-interval'), 10),
        delayTime: parseInt(carouselElement.getAttribute('data-carousel-delay'), 10),
        hoverPauseElements: document.querySelectorAll('[data-hero-carousel-hover-pause-element]')
    }).start();

    // Lazy-load images
    for (const image of document.querySelectorAll('[data-src]')) {
        image.setAttribute('src', image.getAttribute('data-src'));
    }

    // Animate dinosaur interject when element comes into view.
    var waypoint = new Waypoint({
        element: document.querySelector('[data-dino]'),
        handler: once(() => {
            animateDinosaur(500);
        }),
        offset: '100%'
    });

    // Animate leopard girl illustration in enterprise section
    animateLeopardGirl(document.querySelector('[data-leopard-girl]'));

    createScrollableElements();
    scrollOnHover('[data-scrollable]');

    centerAlignScrollableElement('[data-scrollable="examples"]')
        .then((el) => {
            for (let card of document.querySelectorAll('[data-design-card]')) {
                card.style.visibility = 'visible';
            }
        });

    createVideoPlayer();

    // Accordions
    Accordion.create();

    VideoHero.create();
});



/** WEBPACK FOOTER **
 ** ./js/marketing/home.js
 **/